export default {
  pageNotFound: {
    text1: 'Não encontramos a página que você procura!',
    link: 'Volte à página inicial',
    text2: 'ou veja nossos conteúdos ↓',
  },
}
